// extracted by mini-css-extract-plugin
export default {"group":"InstallmentsForm_group__uhMu4","error":"InstallmentsForm_error__VokJZ","form":"InstallmentsForm_form__tGlEj"};